import { formatNumberZero } from '@utils/Format'

// Quantidade exibida na célula: no máximo 2 casas. O valor completo (todas as
// casas) fica no tooltip e é copiado ao clicar.
export const QUANTITY_DISPLAY_DECIMALS = 2
// Teto de casas ao montar o valor completo, para evitar ruído de ponto flutuante.
export const QUANTITY_FULL_MAX_DECIMALS = 12

export const hasQuantityValue = (quantidade) =>
  quantidade !== null &&
  quantidade !== undefined &&
  String(quantidade).trim() !== ''

// Representação decimal simples (com ponto), expandindo notação científica
// (ex.: "1e-8" -> "0.00000001") e removendo zeros à direita. É o valor copiado
// ao clicar — "cru", sem separador de milhar, pronto para reuso em planilhas.
export const toPlainNumberString = (value) => {
  const num = Number(value)
  if (!Number.isFinite(num)) return String(value)
  let plain = String(num)
  if (plain.includes('e') || plain.includes('E')) {
    plain = num.toFixed(QUANTITY_FULL_MAX_DECIMALS)
    if (plain.includes('.')) {
      while (plain.endsWith('0')) plain = plain.slice(0, -1)
      if (plain.endsWith('.')) plain = plain.slice(0, -1)
    }
  }
  return plain
}

const countDecimals = (value) => {
  const parts = toPlainNumberString(value).split('.')
  return parts.length > 1 ? parts[1].length : 0
}

// Valor completo em ptBR preservando todas as casas decimais existentes.
// Usado no tooltip (hover) da célula de quantidade.
export const formatQuantityFull = (quantidade) => {
  const num = Number(quantidade)
  if (!Number.isFinite(num)) return String(quantidade)
  const decimals = Math.min(countDecimals(quantidade), QUANTITY_FULL_MAX_DECIMALS)
  return formatNumberZero(num, decimals)
}

// Valor exibido na célula: no máximo QUANTITY_DISPLAY_DECIMALS casas. Se o
// arredondamento zerar um valor real diferente de zero (cota minúscula), cai
// para a precisão completa para não exibir um "0" enganoso.
export const formatQuantityDisplay = (quantidade) => {
  const num = Number(quantidade)
  if (!Number.isFinite(num)) return String(quantidade)
  const display = formatNumberZero(num, QUANTITY_DISPLAY_DECIMALS)
  if (num !== 0 && display === '0') return formatQuantityFull(quantidade)
  return display
}
